import './TncLicenseAgreement.css';

import {OpenWebURL} from '../../../utils/util';

import React from 'react';
import {useTranslation} from 'react-i18next';

const ExternalLink = ({url, label}) => (
  <a
    href="#"
    onClick={(e) => {
      e.preventDefault();
      OpenWebURL('weburl', url);
    }}
  >
    {label}
  </a>
);

export const UserAggrement = (t) => {
  return (
    <>
      {' '}
      <p className="UserAgreement">
        {t('JOHNDEERE_MYFINANCIAL_END_USER_AGREEMENT')}
      </p>
      <p className="BoldPara">
        {t('PLEASE_READ_THIS_END_USER_LICENSE_AGREEMENT')}
      </p>
      <p>{t('Eula_The_Licensed')}</p>
      <p>{t('Eula_You_Certify')}</p>
      <p>{t('Eula_FirstPointContent')}</p>
      <p>{t('Eula_SecondPointContent')}</p>
      <p>{t('Eula_ThirdPointContent')}</p>
      <p>{t('Eula_ForthPointContent')}</p>
      <p>
        <span>{t('Eula_FifthPointContent')}</span>
        <ExternalLink
          url={t('Eula_FifthPointLink1')}
          label={t('Eula_FifthPointLink1')}
        />
        <span>{t('Eula_FifthPointContinuation1')}</span>

        <span>{t('Eula_FifthPointContinuation3')}</span>
      </p>
      <p>{t('Eula_SixthPointContent')}</p>
      <p className="BoldPara">{t('Eula_SeventhPointContentB')}</p>
      <p className="BoldPara">{t('Eula_EigthPointContentB')}</p>
      <p>{t('Eula_NinthPointContent')}</p>
      <p>{t('Eula_TenthPointContent')}</p>
      <p>{t('Eula_EleventhPointContent')}</p>
      <p>{t('Eula_TwelfthPointContent')}</p>
      <p>{t('Eula_ThirteenthPointContent')}</p>
      <p>
        <span>{t('Eula_ForteenthPointContent')}</span>
        <span>
          <ExternalLink
            url="mailto:MobileApplicationSupport@JohnDeere.com"
            label="MobileApplicationSupport@JohnDeere.com"
          />
        </span>
        <span>{t('Eula_FourteenthPointSend')}</span>
      </p>
      <p>{t('Eula_ForteenthPointContinuation')}</p>
      <p>{t('Eula_FifteenthPointContent')}</p>
      <p />
      <p>{t('ANNEX1')}</p>
      <p className="BoldPara">{t('PRIVACY_STATEMENT_EUROPE')}</p>
      <p>{t('JD_MOBILE_APPLICATION')}</p>
      <p>{t('LICENSED_APPLICATION')}</p>
      <p className="BoldPara">{t('INFORMATION_CONTROLLER')}</p>
      <p>{t('INFORMATION_CONTROLLER_DESC')}</p>
      <p className="BoldPara">{t('LEGAL_DATA_PROCESSING')}</p>
      <p>{t('LEGAL_DATA_PROCESSING_DESC')}</p>
      <p className="BoldPara">{t('RETENTION_PERIOD')}</p>
      <p>{t('Retention Period_DESC')}</p>
      <p className="BoldPara">{t('CATEGORIES_OF_RECIPIENTS')}</p>
      <p>{t('CATEGORIES_OF_RECIPIENTS_DESC')}</p>
      <p className="BoldPara">{t('DATA_SUBJECT_RIGHTS')}</p>
      <p>
        {t('DATA_SUBJECT_RIGHTS_DESC1')}
        <ExternalLink url={t('JD_PRIVACY_LINK')} label={t('JD_PRIVACY_LINK')} />
        .
      </p>
      <p>{t('DATA_SUBJECT_RIGHTS_DESC2')}</p>
      <p>
        {t('DATA_SUBJECT_RIGHTS_DESC3')}
        <ExternalLink url={t('JD_PRIVACY_LINK')} label={t('JD_PRIVACY_LINK')} />
        .
      </p>
    </>
  );
};

const TncLicenseAgreement = (props) => {
  const {t} = useTranslation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <div className="LicenseAggrementWrapper">
      <div className="euladiv">
        <div className="eulabody">
          <div className="TncLinespace">
            <p>{t('PLEASE_REVIEW_NOTE')}</p>
            <p>{t('JOHN_DEERE_FINANCIAL')}</p>
            <p>{t('MYFINANICAL')}</p>
            <p>{t('EFFECTIVE_DATE')}</p>
            <p>{t('TERMS_AND_CONDITIONS')}</p>
          </div>
          <p>{t('TERMS_AND_CONDITIONS_DESC1')}</p>
          <p>{t('TERMS_AND_CONDITIONS_DESC2')}</p>
          <p className="BoldPara">{t('TERMS_AND_CONDITIONS_DESC3')}</p>
          <p className="TncLinespace">{t('DEFINITIONS')}</p>
          <p className="TncUnderline">{t('DEFINITIONS_PARTIES')}</p>
          <p>{t('DEFINITIONS_PARTIES_DESC1')}</p>
          <p>{t('DEFINITIONS_PARTIES_DESC2')}</p>
          <p>{t('DEFINITIONS_PARTIES_DESC3')}</p>
          <p className="TncUnderline">{t('DEFINITIONS_CONTENT')}</p>
          <p>{t('DEFINITIONS_CONTENT_DESC1')}</p>
          <p>{t('DEFINITIONS_CONTENT_DESC2')}</p>
          <p>{t('DEFINITIONS_CONTENT_DESC3')}</p>
          <p>{t('DEFINITIONS_CONTENT_DESC4')}</p>
          <p>{t('DEFINITIONS_CONTENT_DESC5')}</p>
          <p>{t('DEFINITIONS_CONTENT_DESC6')}</p>

          <p className="TncLinespace">{t('CHANGES_TO_THESE_TERMS')}</p>
          <p>
            {t('CHANGES_TO_THESE_TERMS_DESC1')}
            <span className="TncLineBolder">
              {t('CHANGES_TO_THESE_TERMS_DESC2')}
            </span>
            {t('CHANGES_TO_THESE_TERMS_DESC3')}
          </p>

          <p className="TncLinespace">{t('ELIGIBILITY')}</p>
          <p>{t('ELIGIBILITY_DESC')}</p>

          <p className="TncLinespace">{t('PERMISSION_TO_USE_SITE')}</p>
          <p>{t('PERMISSION_TO_USE_SITE_DESC')}</p>

          <p className="TncLinespace">{t('SITE_AVAILABILITY')}</p>
          <p>{t('SITE_AVAILABILITY_DESC')}</p>

          <p className="TncLinespace">{t('USER_ACCOUNTS')}</p>
          <p>{t('USER_ACCOUNTS_DESC1')}</p>
          <p>
            <span>{t('USER_ACCOUNTS_DESC2')}</span>
            {t('USER_ACCOUNTS_DESC2_LINK_LABEL') && (
              <ExternalLink
                url="https://financials.deere.com/"
                label={t('USER_ACCOUNTS_DESC2_LINK_LABEL')}
              />
            )}
          </p>
          <p>{t('USER_ACCOUNTS_DESC3')}</p>
          <p>{t('USER_ACCOUNTS_DESC4')}</p>
          <p>
            <span>{t('USER_ACCOUNTS_DESC5_1')}</span>
            <ExternalLink
              url={t('USER_ACCOUNTS_DESCLink1')}
              label={t('USER_ACCOUNTS_DESCLink1')}
            />
            <span>{t('USER_ACCOUNTS_DESC5_2')}</span>
          </p>

          <p className="TncLinespace">{t('COMMUNICATION_DEERE_USERS')}</p>
          <p>{t('COMMUNICATION_DEERE_USERS_DESC')}</p>

          <p className="TncLinespace">{t('CONTENT_HEADER')}</p>
          <p className="TncUnderline">{t('RESPONSIBILITYFOR_YOUR_CONTENT')}</p>
          <p>{t('RESPONSIBILITYFOR_YOUR_CONTENT_DESC1')}</p>
          <p>{t('RESPONSIBILITYFOR_YOUR_CONTENT_DESC2')}</p>
          <p>{t('RESPONSIBILITYFOR_YOUR_CONTENT_DESC3')}</p>
          <p>{t('RESPONSIBILITYFOR_YOUR_CONTENT_DESC4')}</p>
          <p>{t('RESPONSIBILITYFOR_YOUR_CONTENT_DESC5')}</p>

          <p className="TncUnderline">{t('OUR_RIGHT_USE_YOUR_CONTENT')}</p>
          <p>{t('OUR_RIGHT_USE_YOUR_CONTENT_DESC1')}</p>
          <p>{t('OUR_RIGHT_USE_YOUR_CONTENT_DESC2')}</p>
          <p>{t('OUR_RIGHT_USE_YOUR_CONTENT_DESC3')}</p>

          <p className="TncUnderline">{t('DEERE_CONTENT_SOFTWARE')}</p>
          <p>{t('DEERE_CONTENT_SOFTWARE_DESC1')}</p>
          <p>{t('DEERE_CONTENT_SOFTWARE_DESC2')}</p>
          <p>{t('DEERE_CONTENT_SOFTWARE_DESC3')}</p>

          <p className="TncUnderline">{t('THIRD_PARTY_CONTENT')}</p>
          <p>{t('THIRD_PARTY_CONTENT_DESC1')}</p>
          <p>{t('THIRD_PARTY_CONTENT_DESC2')}</p>
          <p>{t('THIRD_PARTY_CONTENT_DESC3')}</p>

          <p className="TncLinespace">{t('GUIDLINES_AND_POLICIES')}</p>
          <p className="TncUnderline">{t('ACCEPTABLE_USE')}</p>
          <p>{t('ACCEPTABLE_USE_DESC1')}</p>
          <p>{t('ACCEPTABLE_USE_DESC2')}</p>
          <p>{t('ACCEPTABLE_USE_DESC3')}</p>
          <p>{t('ACCEPTABLE_USE_DESC4')}</p>
          <p>{t('ACCEPTABLE_USE_DESC5')}</p>
          <p>{t('ACCEPTABLE_USE_DESC6')}</p>
          <p>{t('ACCEPTABLE_USE_DESC7')}</p>
          <p>{t('ACCEPTABLE_USE_DESC8')}</p>
          <p>{t('ACCEPTABLE_USE_DESC9')}</p>
          <p>{t('ACCEPTABLE_USE_DESC10')}</p>
          <p>{t('ACCEPTABLE_USE_DESC11')}</p>
          <p>{t('ACCEPTABLE_USE_DESC12')}</p>
          <p>{t('ACCEPTABLE_USE_DESC13')}</p>
          <p>{t('ACCEPTABLE_USE_DESC14')}</p>
          <p>{t('ACCEPTABLE_USE_DESC15')}</p>
          <p>{t('ACCEPTABLE_USE_DESC16')}</p>
          <p>{t('ACCEPTABLE_USE_DESC17')}</p>
          <p>{t('ACCEPTABLE_USE_DESC18')}</p>
          <p>{t('ACCEPTABLE_USE_DESC19')}</p>
          <p>{t('ACCEPTABLE_USE_DESC20')}</p>
          <p className="TncUnderline">{t('PRIVACY_USE')}</p>
          <p>{t('PRIVACY_USE_DESC')}</p>

          <p className="TncUnderline">{t('COPYRIGHT_AND_TRADEMARK')}</p>
          <p>{t('COPYRIGHT_AND_TRADEMARK_DESC1')}</p>
          <p>{t('COPYRIGHT_AND_TRADEMARK_DESC2')}</p>
          <p>{t('COPYRIGHT_AND_TRADEMARK_DESC3')}</p>
          <p>{t('COPYRIGHT_AND_TRADEMARK_DESC4')}</p>
          <p>{t('COPYRIGHT_AND_TRADEMARK_DESC5')}</p>
          <p>{t('COPYRIGHT_AND_TRADEMARK_DESC6')}</p>
          {t('COPYRIGHT_AND_TRADEMARK_DESC7_INTRO') && (
            <p>{t('COPYRIGHT_AND_TRADEMARK_DESC7_INTRO')}</p>
          )}
          {t('COPYRIGHT_AND_TRADEMARK_DESC7_COMPANY') && (
            <p className="BoldPara">
              {t('COPYRIGHT_AND_TRADEMARK_DESC7_COMPANY')}
            </p>
          )}
          <p>{t('COPYRIGHT_AND_TRADEMARK_DESC7')}</p>
          <p>{t('COPYRIGHT_AND_TRADEMARK_DESC8')}</p>

          <p className="TncUnderline">{t('SUGGESTIONS_AND_IMPROVEMENTS')}</p>
          <p>{t('SUGGESTIONS_AND_IMPROVEMENTS_DESC')}</p>

          <p className="TncLinespace">{t('INDEMNITY')}</p>
          <p>{t('INDEMNIT_DESC')}</p>

          <p className="TncLinespace">
            {t('DISCLAIMERS_LIMITATION_LIABILITY_TERMINATION')}
          </p>
          <p className="TncUnderline">
            {t('DISCLAIMERS_LIMITATION_LIABILITY')}
          </p>
          <p>{t('DISCLAIMERS_LIMITATION_LIABILITY_DESC1')}</p>
          <p>{t('DISCLAIMERS_LIMITATION_LIABILITY_DESC2')}</p>
          <p>{t('DISCLAIMERS_LIMITATION_LIABILITY_DESC3')}</p>
          <p>{t('DISCLAIMERS_LIMITATION_LIABILITY_DESC4')}</p>
          <p>{t('DISCLAIMERS_LIMITATION_LIABILITY_DESC5')}</p>

          <p className="TncUnderline">{t('TERMINATION_AND_SUSPENSION')}</p>
          <p>{t('TERMINATION_AND_SUSPENSION_DESC1')}</p>
          <p>{t('TERMINATION_AND_SUSPENSION_DESC2')}</p>

          <p className="TncLinespace">{t('GENERAL')}</p>
          <p>{t('GENERAL_DESC1')}</p>
          <p>{t('GENERAL_DESC2')}</p>
          <p>{t('GENERAL_DESC3')}</p>
          <p>{t('GENERAL_DESC4')}</p>
          <p>{t('GENERAL_DESC5')}</p>
          <p>{t('GENERAL_DESC6')}</p>
          <p>{t('GENERAL_DESC7')}</p>
          <p>{t('GENERAL_DESC8')}</p>
          <p>{t('GENERAL_DESC9')}</p>

          <p className="BoldPara eulaSchedule">{t('SCHEDULE_1')}</p>
          {UserAggrement(t)}
          <hr className="hrFooter" />
          <p className="TncFooter">{t('TNC_FOOTER')}</p>
        </div>
      </div>
    </div>
  );
};

export default TncLicenseAgreement;
